import React from 'react';
import { Box, Container, Typography, Button, Grid, Card, CardContent } from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Home: React.FC = () => {
  const navigate = useNavigate();

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Box id="home">
      {/* Contact Banner */}
      <Box
        sx={{
          height: '70vh',
          backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(/images/hero-bg.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          color: 'white',
        }}
      >
        <Container maxWidth="lg">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Typography
              variant="h1"
              sx={{
                mb: 3,
                fontWeight: 700,
                fontSize: { xs: '2.5rem', md: '4rem' },
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.6)',
                color: '#FFFFFF',
              }}
            >
              Abarcar Group
            </Typography>
            <Typography
              variant="h4"
              sx={{
                mb: 2,
                fontWeight: 500,
                fontSize: { xs: '1.25rem', md: '2rem' },
                textShadow: '1px 1px 3px rgba(0, 0, 0, 0.6)',
                color: '#FFFFFF',
              }}
            >
              Your Trusted Advisors in Professional Services
            </Typography>
            <Typography
              variant="h6"
              sx={{
                mb: 4,
                fontWeight: 400,
                fontSize: { xs: '1rem', md: '1.25rem' },
                textShadow: '1px 1px 2px rgba(0, 0, 0, 0.6)',
                color: '#FFFFFF',
              }}
            >
              Contact us for an obligation free discussion
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              onClick={scrollToContact}
              sx={{
                px: 4,
                py: 2,
                fontSize: '1.1rem',
                fontWeight: 500,
              }}
            >
              Get in Touch
            </Button>
          </motion.div>
        </Container>
      </Box>

    </Box>
  );
};

export default Home; 